import type { TrackableEvent } from "../models/AnalyticsEvent";

const MAX_FAILURES = 3;

type Options = {
  endpoint: string;
  send?: (endpoint: string, body: string) => boolean;
};

function defaultSend(endpoint: string, body: string) {
  return navigator.sendBeacon(endpoint, body);
}

export default function createAnalyticsTransport({
  endpoint,
  send = defaultSend,
}: Options) {
  let failures = 0;

  const track = (event: TrackableEvent) => {
    if (failures >= MAX_FAILURES) {
      return;
    }

    const body = JSON.stringify({
      ...event,
      recordedAt: new Date().toISOString(),
    });

    failures = send(endpoint, body) ? 0 : failures + 1;
  };

  return { track };
}
